import { z } from 'zod';

// ─── Permission Types ───────────────────────────────────────────────

export const PermissionTypeEnum = z.enum(['PAGE', 'ACTION']);
export type PermissionType = z.infer<typeof PermissionTypeEnum>;

export const HttpMethodEnum = z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS', 'HEAD']);
export type HttpMethod = z.infer<typeof HttpMethodEnum>;

export const PermissionDefinitionSchema = z.object({
    type: PermissionTypeEnum,
    method: HttpMethodEnum,
    route: z.string().min(1),
});
export type PermissionDefinition = z.infer<typeof PermissionDefinitionSchema>;

// Frontend hydrates this by comparing the granted list from the API
// against SystemPermissions. Missing → isOn = false, present → isOn = true.
export const PermissionViewModelSchema = PermissionDefinitionSchema.extend({
    isOn: z.boolean(),
});
export type PermissionViewModel = z.infer<typeof PermissionViewModelSchema>;

export type { SystemPermissionKey } from '../constants/permissions.js';
